import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportOverallAISummaryData } from "../../../../models/FacilityReportData";
import { EditableAISummary } from "../EditableAISummary";

interface IOverallAISummarySectionProps {
  overallAISummary?: FacilityReportOverallAISummaryData;
  facilityReportId: string;
  isDownloading: boolean;
}

export const OverallAISummarySection: React.FunctionComponent<
  IOverallAISummarySectionProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `facilityReportsPage.facilityReportDetails.overallAISummarySection.${key}`
    );
  const { overallAISummary, facilityReportId, isDownloading } = props;

  if (!overallAISummary) {
    return null;
  }

  return (
    <div className="overall-ai-summary-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-overall-ai-summary-section"
      >
        <EditableAISummary
          title={t("title")}
          summary={overallAISummary.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="overall_ai_summary"
          isDownloading={isDownloading}
        />
      </div>
    </div>
  );
};
